module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('a', {
    attrs: {
      "id": "page_v"
    }
  }), _vm._v(" "), _c('h1', {
    staticClass: "toc-title"
  }, [_vm._v("Contents")]), _vm._v(" "), _c('h2', {
    staticClass: "tocf"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/Acknowledgements"
    }
  }, [_vm._v("Acknowledgements")])]), _vm._v(" "), _c('h2', {
    staticClass: "tocfb"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/Introduction"
    }
  }, [_vm._v("Introduction")])]), _vm._v(" "), _c('h2', {
    staticClass: "tocc"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/Chapter01"
    }
  }, [_c('span', {
    staticClass: "tsp"
  }, [_vm._v("Chapter 1")]), _vm._v(" The Origins of a Great Family")])]), _vm._v(" "), _c('h2', {
    staticClass: "tocc"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/Chapter02"
    }
  }, [_c('span', {
    staticClass: "tsp"
  }, [_vm._v("Chapter 2")]), _vm._v(" The Path to Power")])]), _vm._v(" "), _c('h2', {
    staticClass: "tocc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/Chapter03",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "tsp"
  }, [_vm._v("Chapter 3")]), _vm._v(" Heretics and Martyrs")])]), _vm._v(" "), _c('h2', {
    staticClass: "tocc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/Chapter04",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "tsp"
  }, [_vm._v("Chapter 4")]), _vm._v(" A New Regime")])]), _vm._v(" "), _c('h2', {
    staticClass: "tocc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/Chapter05",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "tsp"
  }, [_vm._v("Chapter 5")]), _vm._v(" The Hunt for a King")])]), _vm._v(" "), _c('h2', {
    staticClass: "tocc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/Chapter06",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "tsp"
  }, [_vm._v("Chapter 6")]), _vm._v(" The Secretary’s Circle")])]), _vm._v(" "), _c('h2', {
    staticClass: "tocc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/Chapter07",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "tsp"
  }, [_vm._v("Chapter 7")]), _vm._v(" Patronage, Influence and Intrigue")])]), _vm._v(" "), _c('h2', {
    staticClass: "tocc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/Chapter08",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "tsp"
  }, [_vm._v("Chapter 8")]), _vm._v(" A Family Man")])]), _vm._v(" "), _c('h2', {
    staticClass: "tocc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/Chapter09",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "tsp"
  }, [_vm._v("Chapter 9")]), _vm._v(" Treachery and Victory")])]), _vm._v(" "), _c('h2', {
    staticClass: "tocc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/Chapter10",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "tsp"
  }, [_vm._v("Chapter 10")]), _vm._v(" The Final Decade")])]), _vm._v(" "), _c('h2', {
    staticClass: "tocc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/Chapter11",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "tsp"
  }, [_vm._v("Chapter 11")]), _vm._v(" The Cecil Succession")])]), _vm._v(" "), _c('h2', {
    staticClass: "tocc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/Chapter12",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "tsp"
  }, [_vm._v("Chapter 12")]), _vm._v(" Crisis and Rebellion")])]), _vm._v(" "), _c('h2', {
    staticClass: "tocc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/Chapter13",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "tsp"
  }, [_vm._v("Chapter 13")]), _vm._v(" The Queen is Dead, Long Live the King")])]), _vm._v(" "), _c('h2', {
    staticClass: "tocc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/Chapter14",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "tsp"
  }, [_vm._v("Chapter 14")]), _vm._v(" Gunpowder")])]), _vm._v(" "), _c('h2', {
    staticClass: "tocc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/Epilogue",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "tsp"
  }, [_vm._v("Epilogue")]), _vm._v(" The Legacy of a Great Family")])]), _vm._v(" "), _c('h2', {
    staticClass: "tocbt"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/Author",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Author’s Final Note")])]), _vm._v(" "), _c('h2', {
    staticClass: "tocb"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/Notes",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Endnotes")])]), _vm._v(" "), _c('h2', {
    staticClass: "tocb"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/Bibliography",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Bibliography")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-13c59a56","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/Toc.vue
// module id = 69
// module chunks = 0